import axios from 'axios';

// LOT URGENT P0 FE-1 — intercepteur axios global pour les reponses HTTP 429.
// Resout BUG-RATELIMIT-2 : sans cet intercepteur, un 429 residuel laissait
// l'UI vide silencieusement (etat React = liste vide, aucun message).
//
// Strategie de retry (decision Jerome Q3) : respecter le header Retry-After
// si present, sinon backoff exponentiel 1s / 2s / 4s ; max 3 tentatives.
// Apres 3 echecs -> handler enregistre (toast i18n) + rejet de l'erreur.

const MAX_RETRIES = 3;

let _rateLimitHandler = null;

/**
 * Enregistre le handler appele quand un 429 persiste apres MAX_RETRIES.
 * Appele par <ApiInterceptorBridge/> avec un callback qui affiche un toast.
 */
export function registerRateLimitHandler(handler) {
  _rateLimitHandler = handler;
}

/**
 * Gestionnaire d'erreur de l'intercepteur axios. Exporte pour les tests.
 * - status != 429 -> propage l'erreur telle quelle (aucun retry)
 * - 429 et MAX_RETRIES atteint -> handler (toast) + rejet
 * - 429 sinon -> attend (Retry-After ou backoff exponentiel) puis rejoue
 */
export async function handleRateLimitError(error) {
  if (error?.response?.status !== 429) {
    return Promise.reject(error);
  }

  const config = error.config || {};
  const retryCount = config.__rateLimitRetryCount || 0;

  if (retryCount >= MAX_RETRIES) {
    if (_rateLimitHandler) {
      try {
        _rateLimitHandler();
      } catch (handlerError) {
        // Un handler defaillant ne doit jamais casser le flux axios.
      }
    }
    return Promise.reject(error);
  }

  config.__rateLimitRetryCount = retryCount + 1;

  // Delai : Retry-After (secondes) si fourni par le serveur, sinon backoff
  // exponentiel 1s / 2s / 4s selon le numero de tentative.
  let delayMs;
  const retryAfterRaw = error.response.headers?.['retry-after'];
  const retryAfterSec = retryAfterRaw != null ? parseInt(retryAfterRaw, 10) : NaN;
  if (!Number.isNaN(retryAfterSec) && retryAfterSec >= 0) {
    delayMs = retryAfterSec * 1000;
  } else {
    delayMs = Math.pow(2, config.__rateLimitRetryCount - 1) * 1000;
  }

  await new Promise((resolve) => setTimeout(resolve, delayMs));
  return axios(config);
}

/**
 * Installe l'intercepteur sur l'instance axios globale. A appeler une fois
 * au boot de l'application (cf. index.js). Option 2 du mini-audit : aucun
 * refactor des ~36 fichiers qui utilisent axios directement.
 */
export function installRateLimitInterceptor() {
  axios.interceptors.response.use((response) => response, handleRateLimitError);
}
